"use client";

import Script from "next/script";

type IMobileSpBigBannerAdProps = {
  adElementId: string;
  asid: number;
};

/**
 * i-mobileスマホ用ビッグバナー広告コンポーネント（320x50）
 * i-mobileの広告スクリプトを読み込み、広告領域をレンダリング
 */
export default function IMobileSpBigBannerAd({ adElementId, asid }: IMobileSpBigBannerAdProps) {
  //----------
  // デバッグ用フラグ
  // true にすると広告エリアを黒塗りで表示（配信前の表示確認用）
  //----------
  const DEBUG_SHOW_PLACEHOLDER = false;

  //----------
  // 広告設定
  // @note 公開識別子のため、直接埋め込みで問題なし
  //----------
  const PID = 84498;
  const MID = 590456;

  if (DEBUG_SHOW_PLACEHOLDER) {
    return (
      <div
        style={{
          width: "100%",
          maxWidth: 320,
          height: 100,
          backgroundColor: "#000",
        }}
      />
    );
  }

  return (
    <div id={adElementId}>
      <Script
        async
        src="https://imp-adedge.i-mobile.co.jp/script/v1/spot.js?20220104"
        strategy="afterInteractive"
      />
      <Script
        id={`imobile-sp-big-banner-${asid}`}
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `(window.adsbyimobile=window.adsbyimobile||[]).push({pid:${PID},mid:${MID},asid:${asid},type:"banner",display:"inline",elementid:"${adElementId}"});`,
        }}
      />
    </div>
  );
}
